import React, { useRef } from "react";
import { Outlines, useGLTF } from "@react-three/drei";
import { useEffect } from "react";
import * as THREE from 'three'
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/00-Forest.glb");

  let built = props.built
  const model = useRef()
  let outlinesShown = true

  const outlineThickness = .008

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }

  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere052.geometry}
        material={materials["01-TreeGreen1"]}
        position={[0.527, 0.319, -0.443]}
        rotation={[-1.084, 0.097, 2.811]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube024.geometry}
        material={materials["00-Base2"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube036.geometry}
        material={materials["01-TreeTrunk"]}
        position={[0.058, 0.068, -0.211]}
        rotation={[-Math.PI, 1.418, -Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube043.geometry}
        material={materials["04-RocksGray"]}
        position={[-0.564, 0.287, 0.641]}
        rotation={[0, 0.946, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube721.geometry}
        material={materials["00-Grass1"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere032.geometry}
        material={materials["01-TreeGreen2"]}
        position={[0.431, 0.396, -0.798]}
        rotation={[-2.403, 1.337, Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/00-Forest.glb");